/**
 * Grid
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
var renderChildren = function (children, margin) {
    var renderedChildren = React.Children.map(children, function (child) {
        var props = child && child.props ? __assign({}, child.props) : {};
        props.margin = margin;
        if (child) {
            return React.cloneElement(child, props);
        }
        else
            return false;
    });
    return renderedChildren;
};
/** Grid component using tailwind classes. */
var Grid = function (_a) {
    var _b = _a.padding, padding = _b === void 0 ? true : _b, _c = _a.margin, margin = _c === void 0 ? true : _c, className = _a.className, children = _a.children;
    return (React.createElement("div", { className: "mx-auto max-w-site" },
        React.createElement("div", { className: clsx(className, 'flex grid-item', margin && '-ml-4', padding && 'lg:py-6 lg:pl-6 py-4 pl-4') }, renderChildren(children, margin))));
};
var getWidthClass = function (span, margin) {
    if (!span) {
        return span;
    }
    if (span === 12) {
        return 'w-full';
    }
    else if (margin) {
        return "w-grid-" + span + "/12";
    }
    else {
        return "w-" + span + "/12";
    }
};
/** Grid Cell component using tailwind classes. */
var Cell = function (_a) {
    var span = _a.span, desktop = _a.desktop, tablet = _a.tablet, className = _a.className, _b = _a.margin, margin = _b === void 0 ? true : _b, children = _a.children, htmlAttributes = __rest(_a, ["span", "desktop", "tablet", "className", "margin", "children"]);
    return (React.createElement("div", __assign({ className: clsx(className, margin && 'mx-4', span && getWidthClass(span, margin), desktop && "lg:" + getWidthClass(desktop, margin), tablet && "md:" + getWidthClass(tablet, margin)) }, htmlAttributes), children));
};
export { Grid, Cell };
